import React from 'react';

import PropTypes from 'prop-types';

import { PositionedOverlay } from 'reaxl';

import MediaGalleryImage from './MediaGalleryImage';
import MediaOverlayButton from './MediaOverlayButton';

function MediaSliderShowcase({
    type = 'spin', // 'spin' or 'video'
    src = '',
    videoThumbnail,
    alt = '',
    mediaType,
    hasFyusion,
    listingTitle,
    videoIndex = 0,
    onClick = () => { },
}) {
    const getImageSrc = () => {
        if (type === 'video') {
            return videoThumbnail || src;
        }
        return src;
    };

    const getId = () => {
        if (type === 'video') {
            return `video-${videoIndex}`;
        }
        return 'spin360';
    };

    const getAltText = () => {
        if (alt) return alt;

        if (type === 'video') {
            return `${listingTitle} video ${videoIndex + 1}`;
        }
        return `${listingTitle} 360° Tour`;
    };

    return (
        <PositionedOverlay
            id={getId()}
            style={{ height: 'auto', display: 'flex' }}
        >
            <PositionedOverlay.Base>
                <MediaGalleryImage
                    alt={getAltText()}
                    isSlider
                    hasFyusion={type === 'spin' ? hasFyusion : undefined}
                    lazyImage={false}
                    fetchPriority="high"
                    loading="eager"
                    mediaType={mediaType}
                    src={getImageSrc()}
                    type="main"
                    onClick={onClick}
                />
            </PositionedOverlay.Base>
            <PositionedOverlay.Anchor position="center">
                <MediaOverlayButton
                    type={type}
                    onClick={onClick}
                />
            </PositionedOverlay.Anchor>
        </PositionedOverlay>
    );
}

MediaSliderShowcase.propTypes = {
    type: PropTypes.oneOf(['spin', 'video']).isRequired,
    src: PropTypes.string,
    videoThumbnail: PropTypes.string,
    alt: PropTypes.string,
    mediaType: PropTypes.string,
    hasFyusion: PropTypes.bool,
    listingTitle: PropTypes.string,
    videoIndex: PropTypes.number,
    onClick: PropTypes.func,
};

export default React.memo(MediaSliderShowcase);
